/**
 * Modo demo: oculta visualmente los datos sensibles para la grabación de cápsulas de
 * video.
 *
 * El ocultamiento es solo de presentación: los datos llegan completos al front y nadie
 * los altera, así que reportes, auditorías, gráficos, exportaciones y el mapa en tiempo
 * real siguen funcionando con la información real del perfil.
 *
 * El grueso del trabajo lo hacen las reglas CSS de migps.css, que con la clase
 * demo-mode en el body difuminan todas las celdas de tabla, los desplegables de
 * búsqueda y lo que se teclea en los campos. Este módulo cubre lo que queda fuera de
 * esas reglas: valores sueltos en fichas, popups y listados que no son tablas.
 *
 * No es un control de seguridad: el valor real sigue estando en la respuesta y en el
 * DOM. Sirve para que no quede a la vista en pantalla ni en la grabación.
 */

import store from '@/store';

export function isDemoMode() {
  return store.state.isDemo === true;
}

/**
 * Clase CSS para un valor sensible. Quien llama decide qué es sensible pasando el
 * nombre del campo; un campo vacío no oculta nada, que es lo que permite recorrer una
 * lista donde solo algunos elementos lo son.
 */
export function demoFieldClass(field) {
  return isDemoMode() && field ? 'demo-hidden' : '';
}

/**
 * Valor para atributos que el blur no alcanza, como el title de una celda: el tooltip
 * nativo del navegador se dibuja fuera del elemento y mostraría el dato en limpio.
 */
export function demoFieldValue(field, value) {
  return demoFieldClass(field) ? '' : value;
}

export default { isDemoMode, demoFieldClass, demoFieldValue };
